import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useCampaignContext } from "common/helpers/CampaignContext";

import useCampaignSchedule from "../../../datahooks/useCampaignSchedule";
import { formattedTimezone, isValidSchedule } from "../../../utils";
import Schedule from "../../Schedule";
import SectionHeading from "../../SectionHeading";
import StepperNextButton from "../../StepperNextButton";
import Stepper from "../Stepper";
import FlowsPreview from "./FlowsPreview";

import type { CampaignFlow } from "../../../types";

export default function CampaignSchedule({ flows }: { flows: CampaignFlow[] }) {
  const { t } = useTranslation("campaigns");
  const { schedule: campaignSchedule } = useCampaignContext();
  const { timezone: initialTimezone, ...initialSchedule } = campaignSchedule;
  const navigate = useNavigate();
  const [schedule, setSchedule] = useState(initialSchedule);
  const [selectedTimezone, setSelectedTimezone] = useState(
    formattedTimezone(initialTimezone),
  );

  const { setCampaignSchedule, isSettingCampaignSchedule } =
    useCampaignSchedule();

  function goToCampaignReview() {
    const { label, offset } = selectedTimezone;
    let timezone = null;
    if (offset) {
      timezone = {
        name: label,
        offset,
      };
    }

    setCampaignSchedule({
      schedule: {
        ...schedule,
        timezone,
      },
    }).then(() => navigate("../review"));
  }

  return (
    <>
      <FlowsPreview flows={flows} />

      <SectionHeading
        title={t("scheduleTitle")}
        subtitle={t("scheduleDescription")}
      />

      <Schedule
        schedule={schedule}
        timezone={selectedTimezone}
        setSchedule={setSchedule}
        setSelectedTimezone={setSelectedTimezone}
      />

      <Stepper
        selectedIndex={3}
        nextButtonComponent={
          <StepperNextButton
            onClick={goToCampaignReview}
            disabled={!isValidSchedule(schedule)}
            isLoading={isSettingCampaignSchedule}
          />
        }
      />
    </>
  );
}
